import { motion } from "framer-motion";
import { CalendarClock, Wallet, MapPin, Leaf } from "lucide-react";
import { reveal, revealContainer, viewportOnce } from "../../lib/motion";

const INFO = [
  {
    icon: CalendarClock,
    label: "Pre-Order Only",
    value: "Standard orders: by 5:00pm, 2 days in advance. Large or event orders: 3–5 days in advance.",
  },
  {
    icon: Wallet,
    label: "Minimum Order",
    value: "From NZ$80 per order.",
  },
  {
    icon: MapPin,
    label: "Delivery",
    value: "Available in and around Mount Eden. A delivery fee may apply depending on location.",
  },
  {
    icon: Leaf,
    label: "Dietary Requirements",
    value: "Please let us know about any allergies or dietary requirements when ordering.",
  },
];

export const Ordering = () => (
  <section data-testid="ordering-section" className="bg-surface py-24 md:py-32">
    <div className="mx-auto max-w-[1400px] px-6 md:px-10">
      <div className="max-w-2xl mb-14">
        <span className="label-caps text-sage">Ordering Information</span>
        <h2 className="mt-4 font-serif text-4xl md:text-5xl text-ink">
          Simple, reliable ordering
        </h2>
      </div>
      <motion.div
        variants={revealContainer}
        initial="hidden"
        whileInView="show"
        viewport={viewportOnce}
        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8"
      >
        {INFO.map((it, i) => (
          <motion.div
            key={i}
            variants={reveal}
            data-testid={`ordering-item-${i}`}
            className="bg-cream border border-border p-8 md:p-10"
          >
            <it.icon className="text-gold" size={28} strokeWidth={1.4} aria-hidden="true" />
            <h3 className="mt-6 font-serif text-2xl text-ink">{it.label}</h3>
            <p className="mt-2 text-ink/60 leading-relaxed">{it.value}</p>
          </motion.div>
        ))}
      </motion.div>
    </div>
  </section>
);
